export default __webpack_public_path__ + "media/success.18bb6731.svg";